import React from 'react'
import { Box } from '@mui/material'
import LocalBarIcon from '@mui/icons-material/LocalBar'
import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import CheckIcon from '@mui/icons-material/Check'
import RouletteWheelIcon from '../Brewlette/RouletteWheelIcon'
import { BeerListPartition, BeerFavouritePartition } from './selectionHelpers'
import styles from './SelectionActionBar.module.css'

interface ActionButtonsProps {
  showNotificationState: boolean
  currentMessage: string
  shouldShowSelectionButtons: boolean
  showBrewlette: boolean
  listPartition: BeerListPartition
  favouritePartition: BeerFavouritePartition
  onTastingListClick: () => void
  onFavouriteClick: () => void
  onBrewletteClick?: () => void
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  showNotificationState,
  currentMessage,
  shouldShowSelectionButtons,
  showBrewlette,
  listPartition,
  favouritePartition,
  onTastingListClick,
  onFavouriteClick,
  onBrewletteClick
}) => {
  if (showNotificationState) {
    return (
      <Box className={styles.notification} role="status" aria-live="polite">
        <CheckIcon className={styles.notificationIcon} />
        <span className={styles.notificationText}>{currentMessage}</span>
      </Box>
    )
  }

  return (
    <>
      {shouldShowSelectionButtons && (
        <>
          <button
            onClick={onTastingListClick}
            className={`${styles.actionButton} ${!listPartition.shouldAdd ? styles.actionButtonRemove : ''} ${styles.actionButtonCompact}`}
            aria-label={listPartition.shouldAdd ? 'Add to Tasting List' : 'Remove from Tasting List'}
            data-tour="tasting-list-button"
          >
            <LocalBarIcon className={`${styles.actionIcon} ${styles.actionIconCompact}`} />
            <span className={styles.actionText}>
              {`${listPartition.shouldAdd ? 'Add' : 'Remove'} ${listPartition.displayCount} ${listPartition.shouldAdd ? 'to Tasting List' : 'from Tasting List'}`}
            </span>
          </button>
          
          <button
            onClick={onFavouriteClick}
            className={`${styles.actionButton} ${!favouritePartition.shouldFavourite ? styles.actionButtonRemove : ''} ${styles.actionButtonCompact}`}
            aria-label={favouritePartition.shouldFavourite ? 'Add to Favourites' : 'Remove from Favourites'}
          >
            {favouritePartition.shouldFavourite ? (
              <FavoriteBorderIcon className={`${styles.actionIcon} ${styles.actionIconCompact}`} />
            ) : (
              <FavoriteIcon className={`${styles.actionIcon} ${styles.actionIconCompact}`} />
            )}
            <span className={styles.actionText}>
              {`${favouritePartition.shouldFavourite ? 'Add' : 'Remove'} ${favouritePartition.displayCount} ${favouritePartition.shouldFavourite ? 'to Favourites' : 'from Favourites'}`}
            </span>
          </button>
        </>
      )}

      {showBrewlette && onBrewletteClick && (
        <button
          onClick={onBrewletteClick}
          className={`${styles.actionButton} ${styles.brewletteActionButton} ${styles.actionButtonCompact}`}
          aria-label="Open Brewlette"
          data-tour="brewlette-button"
        >
          <RouletteWheelIcon size={24} />
          <span className={styles.actionText}>Brewlette</span>
        </button>
      )}
    </>
  )
}
